import { Tag } from "primereact/tag";

type ContentTagProps = {
  value: string;
  severity?: null | "success" | "warning" | "secondary" | "info" | "danger" | "contrast";
  rounded?: boolean;
  className?: string;
  style?: React.CSSProperties;
  /** data-testid applied to the Tag; omit when rendered per-item to avoid duplicate test ids */
  testId?: string;
};

export function ContentTag({
  value,
  severity = null,
  rounded = true,
  className = "bg-elevation-1",
  style,
  testId,
}: ContentTagProps) {
  return (
    <Tag
      value={value}
      severity={severity}
      rounded={rounded}
      className={className}
      data-testid={testId}
      style={{ width: "fit-content", ...style }}
    />
  );
}
